import { useEffect, useState } from "react";
import { generateLinkWithLang } from "../../../utils/linkGenerator";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { openSheet } from "../../../store/sheetToggler";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/general/button";
import { HiMinus, HiPlus } from "react-icons/hi";
import services from "../../../services";
import SelectCurrency from "../../../components/general/selectCurrency";

export const ProductBoxMini = ({
  product,
  onAdd,
  isStaticProduct,
  staticLink,
  scrollTop,
  staticLinkText,
  linkBtnClasses,
  stateVariableObj,
  hideCount = false,
  isSquared = false,
  totalBundlesToBeAchieved = "2000",
  setProductQty,
  defaultPriceGeneral,
  deliveredDescription,
  showCounter = true,
  showCustomCounter=false,
  customDeliveredDescription,
  setCurrentCurrency,
  hideFlag,
  productQty,  // 👈 Use this directly from props
  pricingFilter,
  recurring = 'one-off',
}) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const dispatch = useDispatch();

  const [deliveredCount, setDeliveredCount] = useState(null);

  useEffect(() => {
    setProductQty(defaultPriceGeneral)
  }, [])

  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    const quantity = isNaN(value) || value === "" || Number(value) <= 0
      ? 1
      : Math.floor(Number(value));
    
    setProductQty(quantity);
  };

  const handleIncrement = () => {
    setProductQty(prev => prev + 1);
  };

  const handleDecrement = () => {
    setProductQty(prev => Math.max(1, prev - 1));
  };

  useEffect(() => {
    if (!product?.creator) return;

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000); // abort after 3 sec

    const fetchCount = async () => {
      try {
        let pageUrl = window.location.pathname;
        if (pageUrl.startsWith('/')) {
          pageUrl = pageUrl.substring(1); // remove the leading slash
        }

        const code = product.creator;

        const res = await services.getLatestGazaOrders(pageUrl, code);

        const count = typeof res.data === "number" ? res.data : (res?.data?.count ?? 0);
        setDeliveredCount(count);
      } catch (err) {
        console.warn("🕒 API took too long or failed:", err.message);
      } finally {
        clearTimeout(timeout);
      }
    };

    fetchCount();

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [product?.creator]);

  const handleAddToCart = (product, quantity) => {
    const productWithRecurring = {
      ...product,
      recurring: recurring
    };
    onAdd(productWithRecurring, quantity);
    dispatch(openSheet());
  };

  return (
    <div
      className={`flex gap-3 items-center w-full justify-between bg-[#D1F4FF] p-4 sm:p-8 productMinBox ${!isSquared && "rounded-md"}`}
    >
      {product ? (
        isStaticProduct ? (
          scrollTop && scrollTop >= 0 ? (
            <CustomButton
              onClick={() => {
                window.scroll({
                  top: scrollTop,
                  left: 0,
                  behavior: "smooth",
                });
              }}
              title={staticLinkText ? staticLinkText : "Zakat Calculator"}
              className={`${linkBtnClasses ? linkBtnClasses : `${!isSquared && "!rounded-md"} !text-xs !h-[32px] !px-3 mt-2`}`}
            />
          ) : (
            <CustomButton
              state={stateVariableObj}
              link={`${staticLink ? staticLink : "/zakat-calculator"}`}
              title={staticLinkText ? staticLinkText : "Zakat Calculator"}
              className={`${linkBtnClasses ? linkBtnClasses : `${!isSquared && "!rounded-md"} !text-xs !h-[32px] !px-3 mt-2`}`}
            />
          )
        ) : (
          <div className="flex flex-col gap-3 w-full">
            <div className="flex items-center gap-2 justify-between w-full">
              {!hideCount && (
                <>
                {pricingFilter && (
                  <div className='min-w-[100px]' dir="ltr">
                    <SelectCurrency
                      onChangeCurrency={(e) => setCurrentCurrency(e.value)}
                      classNamePrefix="orphan_select"
                      hideFlag={hideFlag}
                      className={`${isSquared && '[&>div]:!rounded-none'}`}
                    />
                  </div>
                )}
                  <div  
                    className={`flex gap-1 px-1 flex-[1_1_1] w-full ${!pricingFilter ? 'max-w-[80px]' : ''} items-center border border-[#f60362]  hover:border-[#25b9db] focus:border-[#25b9db] h-12 text-[#777] bg-white ${!isSquared && "rounded-md"}`}
                  >
                  <button
                    onClick={handleDecrement}
                    className={`flex items-center justify-center cursor-pointer ${productQty === 1 ? "opacity-50 !cursor-not-allowed" : ""}`}
                    disabled={productQty === 1}
                  >
                    <HiMinus className="h-3 w-3 font-light text-gray-700" />
                  </button>
                    <input
                      type="number"
                      value={productQty}
                      onChange={handleInputChange}
                      className="w-full text-center appearance-none bg-transparent text-[#777] border-none outline-none hover:outline-none focus:outline-none qty-input text-sm"
                    />
                  <button
                    onClick={handleIncrement}
                    className="flex items-center justify-center cursor-pointer"
                  >
                    <HiPlus className="h-3 w-3 font-ligth text-gray-700" />
                  </button>
                  </div>
                </>
              )}
              <div className="flex gap-2 items-end flex-col w-full flex-1 min-w-max">
                <div className="flex justify-center">
                  <CustomButton
                    onClick={() => {
                      if (product.product_type) {
                        navigate(
                          generateLinkWithLang(product.short_description, lang),
                        );
                      } else {
                        handleAddToCart(product, productQty);
                      }
                    }}
                    title={
                      product.product_type
                        ? product.product_type
                        : lang === "ar"
                          ? "تبرع الان"
                          : lang === "fr"
                            ? "Faites un don maintenant"
                            : lang === "es"
                              ? "Dona ahora"
                              : "Donate Now"
                    }
                    className={`mx-auto !text-sm ${lang === "ar" ? "font-[AlmariMedium]" : ""} !h-12 ${isSquared && "!rounded-none"}`}
                  />
                </div>
              </div>
            </div>
              {showCounter && deliveredCount > 0 && totalBundlesToBeAchieved !== undefined && totalBundlesToBeAchieved !== null && (
                <p className="text-center sm:text-right text-[#777] sm:ml-auto">
                  {deliveredCount} {deliveredDescription} {totalBundlesToBeAchieved}.
                </p>
              )}
              {showCustomCounter && (
                <p className="text-center sm:text-right text-[#777] sm:ml-auto">
                  {customDeliveredDescription}
                </p>
              )}
          </div>
        )
      ) : (
        <div className="flex gap-2 items-center">
          <Skeleton height={36} width={102} />
        </div>
      )}
    </div>
  );
};